import React from "react";

const OnfidoChecks = () => (
  <svg
    width="196"
    height="188"
    viewBox="0 0 196 188"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <rect
        x="4.17114"
        y="21.0417"
        width="154.322"
        height="160.334"
        rx="12"
        fill="#E9EFF5"
      />
      <rect
        x="5.67114"
        y="22.5417"
        width="151.322"
        height="157.334"
        rx="10.5"
        stroke="#B7CCE1"
        strokeWidth="3"
      />
    </g>
    <rect
      x="53.2734"
      y="60.1232"
      width="27.943"
      height="6.01251"
      rx="2"
      fill="#D6E3F0"
    />
    <rect
      x="53.2734"
      y="49.1002"
      width="49.1023"
      height="6.01253"
      rx="2"
      fill="#D6E3F0"
    />
    <rect
      x="53.2734"
      y="38.0772"
      width="39.0814"
      height="6.01253"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M39.6827 50.2902C39.6827 56.5164 34.6354 61.5637 28.4092 61.5637C22.1831 61.5637 17.1357 56.5164 17.1357 50.2902C17.1357 44.064 22.1831 39.0167 28.4092 39.0167C34.6354 39.0167 39.6827 44.064 39.6827 50.2902Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M36.3808 58.2617L44.7558 66.6367M39.6827 50.2902C39.6827 56.5164 34.6354 61.5637 28.4092 61.5637C22.1831 61.5637 17.1357 56.5164 17.1357 50.2902C17.1357 44.064 22.1831 39.0167 28.4092 39.0167C34.6354 39.0167 39.6827 44.064 39.6827 50.2902Z"
      stroke="#92B0CE"
      strokeWidth="3"
    />
    <rect
      x="38.3308"
      y="81.2547"
      width="105"
      height="12"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M33.5812 87.2575C33.5812 91.2617 30.3351 94.5078 26.3309 94.5078C22.3266 94.5078 19.0806 91.2617 19.0806 87.2575C19.0806 83.2532 22.3266 80.0072 26.3309 80.0072C30.3351 80.0072 33.5812 83.2532 33.5812 87.2575Z"
      fill="#E9EFF5"
    />
    <path
      d="M22.8309 87.2547L25.3309 89.7547L30.3309 84.7547M33.5812 87.2575C33.5812 91.2617 30.3351 94.5078 26.3309 94.5078C22.3266 94.5078 19.0806 91.2617 19.0806 87.2575C19.0806 83.2532 22.3266 80.0072 26.3309 80.0072C30.3351 80.0072 33.5812 83.2532 33.5812 87.2575Z"
      stroke="#B7CCE1"
      strokeWidth="1.5"
    />
    <rect
      x="38.3308"
      y="105.255"
      width="105"
      height="12"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M33.5812 111.257C33.5812 115.262 30.3351 118.508 26.3309 118.508C22.3266 118.508 19.0806 115.262 19.0806 111.257C19.0806 107.253 22.3266 104.007 26.3309 104.007C30.3351 104.007 33.5812 107.253 33.5812 111.257Z"
      fill="#E9EFF5"
    />
    <path
      d="M22.8309 111.255L25.3309 113.755L30.3309 108.755M33.5812 111.257C33.5812 115.262 30.3351 118.508 26.3309 118.508C22.3266 118.508 19.0806 115.262 19.0806 111.257C19.0806 107.253 22.3266 104.007 26.3309 104.007C30.3351 104.007 33.5812 107.253 33.5812 111.257Z"
      stroke="#B7CCE1"
      strokeWidth="1.5"
    />
    <rect
      x="38.3308"
      y="129.255"
      width="105"
      height="12"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M33.5812 135.257C33.5812 139.262 30.3351 142.508 26.3309 142.508C22.3266 142.508 19.0806 139.262 19.0806 135.257C19.0806 131.253 22.3266 128.007 26.3309 128.007C30.3351 128.007 33.5812 131.253 33.5812 135.257Z"
      fill="#E9EFF5"
    />
    <path
      d="M22.8309 135.255L25.3309 137.755L30.3309 132.755M33.5812 135.257C33.5812 139.262 30.3351 142.508 26.3309 142.508C22.3266 142.508 19.0806 139.262 19.0806 135.257C19.0806 131.253 22.3266 128.007 26.3309 128.007C30.3351 128.007 33.5812 131.253 33.5812 135.257Z"
      stroke="#B7CCE1"
      strokeWidth="1.5"
    />
    <rect x="97.3308" y="128.255" width="24" height="10" fill="#D6E3F0" />
    <rect
      x="38.3308"
      y="153.255"
      width="105"
      height="12"
      rx="2"
      fill="#D6E3F0"
    />
    <path
      d="M33.5812 159.257C33.5812 163.262 30.3351 166.508 26.3309 166.508C22.3266 166.508 19.0806 163.262 19.0806 159.257C19.0806 155.253 22.3266 152.007 26.3309 152.007C30.3351 152.007 33.5812 155.253 33.5812 159.257Z"
      fill="#E9EFF5"
    />
    <path
      d="M22.8309 159.255L25.3309 161.755L30.3309 156.755M33.5812 159.257C33.5812 163.262 30.3351 166.508 26.3309 166.508C22.3266 166.508 19.0806 163.262 19.0806 159.257C19.0806 155.253 22.3266 152.007 26.3309 152.007C30.3351 152.007 33.5812 155.253 33.5812 159.257Z"
      stroke="#B7CCE1"
      strokeWidth="1.5"
    />
    <g filter="url(#filter1_d)">
      <rect
        x="86.8433"
        y="104.215"
        width="104.217"
        height="65.1357"
        rx="8"
        fill="#E9EFF5"
      />
      <rect
        x="88.3433"
        y="105.715"
        width="101.217"
        height="62.1357"
        rx="6.5"
        stroke="#B7CCE1"
        strokeWidth="3"
      />
    </g>
    <rect
      opacity="0.8"
      x="165.328"
      y="137.838"
      width="18.8705"
      height="4.07098"
      rx="2"
      fill="#B7CCE1"
    />
    <rect
      opacity="0.8"
      x="132.304"
      y="130.526"
      width="51.8941"
      height="4.07098"
      rx="2"
      fill="#B7CCE1"
    />
    <rect
      opacity="0.8"
      x="145.6"
      y="123.213"
      width="38.5989"
      height="4.07097"
      rx="2"
      fill="#B7CCE1"
    />
    <path
      d="M116.412 126.915C116.412 130.547 113.475 133.492 109.852 133.492C106.23 133.492 103.293 130.547 103.293 126.915C103.293 123.283 106.23 120.338 109.852 120.338C113.475 120.338 116.412 123.283 116.412 126.915Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M121.915 142.319C121.448 140.603 119.893 139.413 118.12 139.413H101.583C99.8095 139.413 98.2551 140.603 97.7884 142.319L95.7247 149.905C95.2698 151.578 96.5256 153.226 98.2547 153.226H121.448C123.177 153.226 124.433 151.578 123.978 149.905L121.915 142.319Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M116.412 126.915C116.412 130.547 113.475 133.492 109.852 133.492C106.23 133.492 103.293 130.547 103.293 126.915C103.293 123.283 106.23 120.338 109.852 120.338C113.475 120.338 116.412 123.283 116.412 126.915Z"
      stroke="#92B0CE"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M121.915 142.319C121.448 140.603 119.893 139.413 118.12 139.413H101.583C99.8095 139.413 98.2551 140.603 97.7884 142.319L95.7247 149.905C95.2698 151.578 96.5256 153.226 98.2547 153.226H121.448C123.177 153.226 124.433 151.578 123.978 149.905L121.915 142.319Z"
      stroke="#92B0CE"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <g filter="url(#filter2_d)">
      <path
        d="M185.143 32.0756C185.143 47.6244 172.538 60.2292 156.99 60.2292C141.441 60.2292 128.836 47.6244 128.836 32.0756C128.836 16.5267 141.441 3.92192 156.99 3.92192C172.538 3.92192 185.143 16.5267 185.143 32.0756Z"
        fill="#CDDFFA"
      />
      <path
        d="M156.99 47.5971V28.1816M156.99 22.357V16.5324M185.143 32.0755C185.143 47.6244 172.538 60.2292 156.99 60.2292C141.441 60.2292 128.836 47.6244 128.836 32.0755C128.836 16.5267 141.441 3.92192 156.99 3.92192C172.538 3.92192 185.143 16.5267 185.143 32.0755Z"
        stroke="#3574D4"
        strokeWidth="3"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.171143"
        y="19.0417"
        width="162.322"
        height="168.334"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="82.8433"
        y="102.215"
        width="112.217"
        height="73.1357"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="121.925"
        y="-1"
        width="70.1294"
        height="70.1294"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default OnfidoChecks;
